import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceDetails from "./sections/ServiceDetails";
import PricingPackages from "./sections/PricingPackages";
import GetAQuoteCta from "./sections/GetAQuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceDetails />
      <PricingPackages />
      <GetAQuoteCta />
      <Footer />
    </div>;
}